import angular from 'angular'

import subscriptionPay from './component/subscriptionPay'
import subscriptionPartnerCreateAccount from './component/subscriptionPartnerCreateAccount'
import subscriptionTimeline from './component/subscriptionTimeline'
import subscriptionHelp from './component/subscriptionHelp'
import subscriptionHelpOffrePrintemps2018 from './component/subscriptionHelpOffrePrintemps2018'
import subscriptionHelpOffreEte2018 from './component/subscriptionHelpOffreEte2018'
import subscriptionHelpOffreRentree2018 from './component/subscriptionHelpOffreRentree2018'
import subscriptionHelpOffreAutomne2018 from './component/subscriptionHelpOffreAutomne2018'
import findPdlHelper from './modal/findPdlHelper'
import bypassReadingsAlert from './modal/bypassReadingsAlert'
import subscriptionSwitchStandardOffer from './modal/subscriptionSwitchStandardOffer'
import landscapeConfirmModalCtrl from './modal/landscapeConfirmModalCtrl'
import landscapeModalCtrl from './modal/landscapeModalCtrl'
import subscriptionContactUnknownPRMCtrl from './modal/subscriptionContactUnknownPRM'
import subscriptionCtrl from './subscription'

/* Angular styleguide https://github.com/toddmotto/angular-styleguide */
export default angular
.module('unergie.subscription', [])
.component('subscriptionPay', subscriptionPay)
.component('subscriptionPartnerCreateAccount', subscriptionPartnerCreateAccount)
.component('subscriptionTimeline', subscriptionTimeline)
.component('subscriptionHelp', subscriptionHelp)
.component('subscriptionHelpOffrePrintemps2018', subscriptionHelpOffrePrintemps2018)
.component('subscriptionHelpOffreEte2018', subscriptionHelpOffreEte2018)
.component('subscriptionHelpOffreRentree2018', subscriptionHelpOffreRentree2018)
.component('subscriptionHelpOffreAutomne2018', subscriptionHelpOffreAutomne2018)
.component('findPdlHelper', findPdlHelper)
.component('bypassReadingsAlert', bypassReadingsAlert)
.component('subscriptionSwitchStandardOffer', subscriptionSwitchStandardOffer)
.controller('landscapeConfirmModalCtrl', landscapeConfirmModalCtrl)
.controller('landscapeModalCtrl', landscapeModalCtrl)
.controller('subscriptionContactUnknownPRMCtrl', subscriptionContactUnknownPRMCtrl)
.controller('subscriptionCtrl', subscriptionCtrl)
.name



// WEBPACK FOOTER //
// ./src/states/subscription/subscription.module.js